/** Platform-level roles on User.role (not AccountMembership.role). */
export const PLATFORM_ADMIN_ROLES = ["SUPER_ADMIN", "ADMIN"] as const;

export function isPlatformAdminRole(role: string | null | undefined): boolean {
  return role === "SUPER_ADMIN" || role === "ADMIN";
}
